import { useMemo } from "react";
import { Navigate } from "react-router-dom";
import WorkspaceShell from "./WorkspaceShell";
import WorkspaceSectionBody from "./WorkspaceSectionBody";
import {
  WORKSPACE_THEME,
  canAccessAgentDesk,
  getAgentDeskSections,
  getWorkspaceRole,
} from "./workspaceConfig";

export default function AgentDeskPage() {
  const role = getWorkspaceRole();
  const sections = useMemo(() => getAgentDeskSections(role), [role]);

  if (!canAccessAgentDesk(role)) {
    return <Navigate to="/dashboard" replace />;
  }

  if (!sections.length) {
    return (
      <div className="p-6 max-w-3xl">
        <h1 className="text-2xl font-bold text-gray-900">My Desk</h1>
        <p className="mt-2 text-gray-600">
          No desk tools are enabled for your account yet. Ask a team lead to assign
          you to a team and turn on the right permissions.
        </p>
      </div>
    );
  }

  return (
    <WorkspaceShell
      eyebrow="Daily work"
      title="My Desk"
      subtitle="Your work, today’s targets, and performance — three simple tabs."
      sections={sections}
      accent={WORKSPACE_THEME.primary}
    >
      {({ active, go }) =>
        active ? (
          <WorkspaceSectionBody componentKey={active.component} onGo={go} />
        ) : null
      }
    </WorkspaceShell>
  );
}
